'use client';

import { useTranslations } from 'next-intl';
import { Brain } from 'lucide-react';
import { SettingsItem } from '@/shared/ui/settings';

interface ExtendedThinkingSectionProps {
  isExtendedThinking: boolean;
  onIsExtendedThinkingChange: (value: boolean) => void;
}

/**
 * Extended thinking toggle. Lives inside the "Advanced engine controls" group,
 * which is rendered ONLY for advanced-control holders (Builder Pass,
 * grandfathered Pro/Designer) — see `ScrollableRenderSettings`. By the time
 * this row is shown the user always has the capability, so there is no
 * lock/paywall path here. Mirrors the iOS Engine-section toggle row.
 */
export function ExtendedThinkingSection({
  isExtendedThinking,
  onIsExtendedThinkingChange,
}: ExtendedThinkingSectionProps) {
  const t = useTranslations('render.settings.extendedThinking');

  return (
    <SettingsItem
      icon={Brain}
      title={t('title')}
      paddingClassName="px-4 py-3"
      toggle={{
        checked: isExtendedThinking,
        onCheckedChange: onIsExtendedThinkingChange,
      }}
      rowTogglesSwitch
    />
  );
}
